module.exports = __webpack_public_path__ + "img/logo.2f0b70df.png";